import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "@/pages/Dashboard";
import StreamOverlay from "@/pages/StreamOverlay";
import GameOverlay from "@/pages/GameOverlay";
import Login from "@/pages/Login";
import PublicCommands from "@/pages/PublicCommands";
import HelpPancake from "@/pages/HelpPancake";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/commands" element={<PublicCommands />} />
          <Route path="/help-pancake" element={<HelpPancake />} />
          <Route path="/help-pancake/thanks" element={<HelpPancake />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/overlay" element={<StreamOverlay />} />
          <Route path="/overlay/games" element={<GameOverlay />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors theme="dark" />
    </div>
  );
}

export default App;
